import {GeoJSON} from 'ol/format';
import ImageWMS from 'ol/source/ImageWMS';
import {TileArcGISRest} from 'ol/source.js';
import VectorSource from 'ol/source/Vector.js';
import {Image as ImageLayer, Vector as VectorLayer} from 'ol/layer.js';
import TileLayer from 'ol/layer/Tile.js';
import {bbox as bboxStrategy} from 'ol/loadingstrategy.js';
import {formatoImagen, versionWMS, versionWFS, exepcion, centroid3857, extension3857, proyeccion3857, modificarURLServicioWMS, validarUrl} from './configuracion.js';

const tipoServicio = document.getElementById('tipoServicio'),
direccionWebCapa = document.getElementById('direccionWebCapa'),
conectarServicio = document.getElementById('conectarServicio'),
mensajeServicioWeb = document.getElementById('mensajeServicioWeb'),
capasDisponibles = document.getElementById('capasDisponibles'),
grupoAgregar = document.getElementById('grupoAgregar'),
capasTematicas = document.getElementById('capasTematicas'),
agregarCapas = document.getElementById('agregarCapas'),
limpiarServicio = document.getElementById('limpiarServicio'),
interoperabilidad = document.getElementById('interoperabilidad'),
capasInteroperabilidad = document.getElementById('capasInteroperabilidad');

tipoServicio.addEventListener('change', function() {
    if (['wms', 'wfs', 'rest'].includes(this.value)) {
        direccionWebCapa.value = '';
        direccionWebCapa.focus();
    }
});

conectarServicio.addEventListener('click', function() {
    if (direccionWebCapa.value.length > 0) {
        conectarServicio.innerHTML = '<span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span> Conectando';
        switch (tipoServicio.value) {
            case 'wms':
                conectarServicioOGCWMS();
            break;
            case 'wfs':
                conectarServicioOGCWFS();
            break;
            case 'rest':
                conectarServicioRestArcGIS();
            break;
        }
    } else {
        //const texto = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><strong>Error:</strong> El campo <strong>dirección web</strong> no puede ser vacío.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>';
        //mensajeServicioWeb.innerHTML = texto;
        direccionWebCapa.classList.add('is-invalid');
        direccionWebCapa.focus();
        conectarServicio.innerHTML = '<i class="bi bi-box-arrow-down" ></i> Conectar';
    }
});

function limpiar() {
    mensajeServicioWeb.innerHTML = '';
    direccionWebCapa.classList.remove('is-invalid');
    direccionWebCapa.value = '';
    direccionWebCapa.focus();
    conectarServicio.classList.remove('disabled');
    conectarServicio.innerHTML = '<i class="bi bi-box-arrow-down" ></i> Conectar';
    capasDisponibles.style.display = 'none';
    grupoAgregar.style.display = 'none';
    interoperabilidad.style.display = 'none';
    capasTematicas.innerHTML = '';
    capasInteroperabilidad.innerHTML = '';
}

limpiarServicio.addEventListener('click', function() {
	global.mapa.getLayers().forEach(function(layer) {
		if (layer.get('id') === 'servicioWMS' || layer.get('id') === 'servicioWFS' || layer.get('id') === 'servicioRest') {
            direccionWebCapa.value = '';
			global.mapa.removeLayer(layer);
			global.vista.setCenter(centroid3857);
			if (global.mapa.getSize()[0] > 1296) global.vista.setZoom(6);
			else global.vista.setZoom(5.4);
		}
	});
    limpiar();
});

function conectarServicioOGCWMS(){
    const urlServicioWMS = modificarURLServicioWMS(direccionWebCapa.value.trim());
    if (validarUrl(urlServicioWMS)) {
        fetch(urlServicioWMS, {mode: 'cors'})
        .then(response => {
            if (!response.ok) throw new Error('La solicitud falló');
            return response.text();
        })
        .then(xmlText => {
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(xmlText, 'text/xml');            
            //let layerElements = xmlDoc.querySelectorAll('Layer[queryable="1"][opaque="0"]');
            let grupoCapas = xmlDoc.querySelectorAll('Layer[queryable="1"]');
            capasDisponibles.style.display= 'block';
            grupoAgregar.style.display= 'block';
            limpiarServicio.classList.remove('disabled');
            grupoCapas.forEach(capa => {
                let nombre = capa.querySelector('Name').textContent;
                let titulo = capa.querySelector('Title').textContent;
                const e = document.createElement('option');
                e.textContent = titulo;
                e.value = nombre;
                capasTematicas.appendChild(e);
            });
        })
        .catch(error => {
            const texto = '<div class="alert alert-danger alert-dismissible fade show" role="alert"><strong>Error:</strong> Ocurrió un error al realizar la solicitud.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>';
            mensajeServicioWeb.innerHTML = texto;
            direccionWebCapa.value = '';
            direccionWebCapa.focus();
        });
        mensajeServicioWeb.innerHTML = '';
        conectarServicio.classList.add('disabled');
        direccionWebCapa.classList.remove('is-invalid');
        conectarServicio.innerHTML = '<i class="bi bi-box-arrow-down" ></i>Conectar';
        limpiarServicio.classList.remove('disabled');
    }
    else limpiar();
}

function conectarServicioOGCWFS(){
}

function conectarServicioRestArcGIS() {
    const urlServicioRestArcGIS = direccionWebCapa.value.trim();
    if (validarUrl(urlServicioRestArcGIS)) {
        fetch(`${urlServicioRestArcGIS}?f=json`, { mode: 'cors' })
            .then(response => {
                if (!response.ok) throw new Error('Error al obtener la información del servicio.');
                return response.json();
            })
            .then(data => {
                if (!data.layers) throw new Error('El servicio no contiene capas disponibles.');
                capasDisponibles.style.display = 'block';
                grupoAgregar.style.display = 'block';
                limpiarServicio.classList.remove('disabled');
                capasTematicas.innerHTML = ''; // Limpiar opciones previas
                data.layers.forEach(capa => {
                    const e = document.createElement('option');
                    e.textContent = capa.name;
                    e.value = capa.id;
                    capasTematicas.appendChild(e);
                });
                mensajeServicioWeb.innerHTML = '';
                conectarServicio.classList.add('disabled');
                direccionWebCapa.classList.remove('is-invalid');
                conectarServicio.innerHTML = '<i class="bi bi-box-arrow-down"></i> Conectar';
                limpiarServicio.classList.remove('disabled');
            })
            .catch(error => {
                mostrarMensajeError(error.message);
            });
    } else {
        limpiar();
    }
}

function mostrarMensajeError(mensaje) {
    mensajeServicioWeb.innerHTML = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
        <strong>Error:</strong> ${mensaje}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`;
    direccionWebCapa.value = '';
    direccionWebCapa.focus();
}

agregarCapas.addEventListener('click', function() {
    if (capasTematicas.options.length > 0) {
        interoperabilidad.style.display= 'block';
        const codigo = capasTematicas.selectedIndex,
        idCapa = capasTematicas.value,
        nombreCapa = capasTematicas.options[codigo].innerText.substring(0,25),
        url = direccionWebCapa.value,
        tipo = tipoServicio.value;
        const opcionAEliminar = capasTematicas.querySelector('option[value="' + idCapa + '"]');
        if (opcionAEliminar) opcionAEliminar.remove();
        /*const html = `<div class="row d-flex justify-content-between"><div class="col-auto w-80"><div class="form-check form-switch"><input class="form-check-input" type="checkbox" id="${idCapa}" data-url="${url}" data-capa="${idCapa}" data-tipo="${tipo}" /><label class="form-check-label" for="${idCapa}">${nombreCapa}</label></div></div><div class="col-auto w-20"><div class="dropdown"><i class="bi bi-three-dots-vertical btn btn-secondary custom-dosts-vertical btn-sm" type="button" id="btn${idCapa}" data-bs-toggle="dropdown" aria-expanded="false" ></i><ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2"><li><a class="dropdown-item" id="i${idCapa}" href="#" ><i class="bi bi-info-square-fill"></i> Identificar</a></li></ul></div></div></div>`;
        //capasInteroperabilidad.innerHTML = html;
        capasInteroperabilidad.innerHTML +=html;
        let control = document.getElementById(idCapa);
        control.addEventListener("change", function() {
            if (this.checked) 
                cargarCapa(this.id, true);
            else cargarCapa(this.id, false);
        });*/
        //const idUnico = idCapa + '_' + Date.now();
        const idUnico = idCapa.replace(/^.*?:/, "");
        const html = `
        <div class="row d-flex justify-content-between">
            <div class="col-auto w-80">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="${idUnico}" data-url="${url}" data-capa="${idCapa}" data-tipo="${tipo}" />
                    <label class="form-check-label" for="${idUnico}">${nombreCapa}</label>
                </div>
            </div>
            <div class="col-auto w-20">
                <div class="dropdown">
                    <i class="bi bi-three-dots-vertical btn btn-secondary custom-dosts-vertical btn-sm" type="button" id="btn${idUnico}" data-bs-toggle="dropdown" aria-expanded="false"></i>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                        <li><a class="dropdown-item" id="i${idUnico}" href="#"><i class="bi bi-info-square-fill"></i> Identificar</a></li>
                        <li><a class="dropdown-item"><i class="bi bi-transparency"></i> Transparencia</a><input type="range" class="transparency-slider" id="t${idUnico}" min="0" max="1" step="0.01" value="1"></li>
                    </ul>
                </div>
            </div>
        </div>`;
        capasInteroperabilidad.insertAdjacentHTML('beforeend', html);
        let control = document.getElementById(idUnico);
        control.addEventListener("change", function () {
            cargarCapa(this.id, this.checked);
        });
    }
});

function cargarCapa(id, estado) {
    /*const idCapa = document.getElementById(id);
    const urlWMS = idCapa.getAttribute('data-url'),
    tipo = idCapa.getAttribute('data-tipo');*/
    const input = document.getElementById(id);
    const url = input.dataset.url;
    const tipo = input.dataset.tipo;
    const capaId = input.dataset.capa;
    let capas = global.mapa.getLayers().getArray();
    //let capa = capas.filter(c => c.get('id') === 'i' + id);
    let capa = capas.find(c => c.get('id') === 'i' + id);  // Buscar capa
    /*if (capa.length == 0) {*/
    if (!capa) {  // Si no existe, la creamos
        switch (tipo) {
            case 'wms':
                const servicioWMS = new ImageLayer({
                    id: 'i' + id,
                    //visible: true,
                    visible: estado,
                    source: new ImageWMS({
                        ratio: 1,
                        url: url,
                        crossOrigin: 'Anonymous',
                        params: {
                          'FORMAT': formatoImagen,
                          'VERSION': versionWMS,
                          'TRANSPARENT': true,
                          'STYLES': '',
                          'LAYERS': capaId,
                        }
                    }),
                });
                global.mapa.getLayers().insertAt(capas.length - 1, servicioWMS);
            break;
            /*case 'wfs':
            break;*/
            case 'rest':
                //const dataCapa = 'show:' + idCapa.getAttribute('data-capa');
                //const urlServicioRestArcGIS = urlWMS;
                const servicioRest = new TileLayer({
                    //id: 'servicioRest',
                    id: 'i' + id,
                    extent: extension3857,
                    source: new TileArcGISRest({
                        url: url,
                        params: {
                            'TRANSPARENT': true,
                            //layers: dataCapa,
                            layers: 'show:' + capaId,
                        },
                    }),
                });
                //servicioRest.setVisible(true);
                servicioRest.setVisible(estado);
                //global.mapa.addLayer(servicioRest);
                global.mapa.getLayers().insertAt(capas.length - 1, servicioRest);
            break;
        }
    } else {
        /*const i = capa[0];
        i.setVisible(estado);*/
        capa.setVisible(estado);
    }
}